export default () => ({
  nav: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0 0 20px',
  },
});
